import { render, staticRenderFns } from "./speedLimit.vue?vue&type=template&id=5c35f2b0&scoped=true"
import script from "./speedLimit.vue?vue&type=script&lang=js"
export * from "./speedLimit.vue?vue&type=script&lang=js"
import style0 from "./speedLimit.vue?vue&type=style&index=0&id=5c35f2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_35e1b9026555e837868613c3c720eb09/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35f2b0",
  null
  
)

export default component.exports